export enum graphKeys {
    prevStep = 'С предыдущего шага',
    notPrevStep = 'Не с предыдущего шага',
    sum = 'Всего на шаге'
}
